module.exports = __webpack_public_path__ + "img/2024全部購買符號.99463461.svg";